<div class="why-us">
    <div class="row d-center_0">
        <div class="col-md-6">
            <div class="coin">
                <img src="assets/coin.png" alt="coin">
            </div>

        </div>
        <div class="col-md-6">
            <h4 class="heading">Creating memorability is essential to how you’re digitally styled</h4>
            <p class="desc mt-4">We believe in utilizing unorthodox approaches in making an uncannily impression in the eyes of your audience. Whether you’re a creative or looking to promote an event or maybe a start-up or a corporation looking to brand or rebrand, we have
                answers and solutions for you. Contact us for a free consultation.</p>
        </div>
    </div>
    <div class="row d-center_1 mt-4">

        <div class="col-md-6">
            <div class="multiple-arrow">
                <img src="assets/arrow-imgs.png" alt="arrow">
            </div>
            <!-- <div id="arrowAnim">
                <div class="arrowSliding">
                    <div class="arrow"></div>
                </div>
                <div class="arrowSliding delay1">
                    <div class="arrow"></div>
                </div>
                <div class="arrowSliding delay2">
                    <div class="arrow"></div>
                </div>
                <div class="arrowSliding delay3">
                    <div class="arrow"></div>
                </div>
                <div class="arrowSliding delay4">
                    <div class="arrow"></div>
                </div>
                <div class="arrowSliding delay5">
                    <div class="arrow"></div>
                </div>
                <div class="arrowSliding delay6">
                    <div class="arrow"></div>
                </div>
                <div class="arrowSliding delay7">
                    <div class="arrow"></div>
                </div>
                <div class="arrowSliding delay8">
                    <div class="arrow"></div>
                </div>
                <div class="arrowSliding delay9">
                    <div class="arrow"></div>
                </div>
                <div class="arrowSliding delay10">
                    <div class="arrow"></div>
                </div>

                <div class="arrowSliding delay12">
                    <div class="arrow12"></div>
                </div>
                <div class="arrowSliding delay11">
                    <div class="arrow11"></div>
                </div>
            </div> -->

        </div>
        <div class="col-md-6 text-right">
            <div class="coin">
                <img src="assets/coin.png" alt="coin">
            </div>

        </div>
    </div>
</div>